import { render, staticRenderFns } from "./OfferDetailPage.vue?vue&type=template&id=6ce1488c"
import script from "./OfferDetailPage.vue?vue&type=script&lang=js"
export * from "./OfferDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports